const rules = {
  name: [
    {
      required: true,
      message: "请输入姓名",
      validateTrigger: ["onBlur", "onChange"],
    },
  ],
  id_no: [
    {
      required: true,
      message: "请输入身份证号",
      validateTrigger: ["onBlur", "onChange"],
    },
    {
      message: "请输入正确的身份证号，例如：350201199001234567",
      validateTrigger: ["onBlur", "onChange"],
      validator(_, value) {
        if (value) {
          const reg =
            /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
          // 港澳台正则
          const TWReg = /^[a-zA-Z][0-9]{9}$/;
          const HKReg = /^[A-Z]{1,2}[0-9]{6,10}[0-9A-Z]$/;
          const AMReg = /^[A-Z]{1,2}[0-9]{6,10}[0-9A-Z]$/;

          if (
            reg.test(value) ||
            TWReg.test(value) ||
            HKReg.test(value) ||
            AMReg.test(value)
          ) {
            return Promise.resolve();
          } else {
            return Promise.reject();
          }
        } else {
          return Promise.resolve();
        }
      },
    },
  ],
  ZHReg: [
    {
      message: "请输入正确的身份证号，例如：350201199001234567",
      pattern:
        /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/,
    },
  ],
  TWReg: [
    {
      message: "请输入正确的台湾通行证，例如：12345678",
      pattern: /^\d{8}$/,
    },
  ],
  HKReg: [
    {
      message: "请输入正确的港澳通行证，例如：H12345678",
      pattern: /^(H|M)\d{8}$/,
    },
  ],
  passportReg: [
    {
      message: "请输入正确的护照，例如：a12345678",
      pattern: /^[A-Za-z0-9]{9}$/,
    },
  ],
  email: [
    {
      message: "请输入正确的邮箱",
      pattern:
        /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
    },
  ],
  phone: [
    { required: true, message: "请输入手机或固定电话号码" },
    {
      message:
        "请输入正确的手机或固定电话号码，例如：13512345678或0592-8263159",
      validator(_, value) {
        if (value) {
          if (
            !/^[1][3-9]\d{9}$|([6|9])\d{7}$|[0][9]\d{8}$|6\d{5}$/.test(value) &&
            !/^((0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/.test(value)
          ) {
            return Promise.reject();
          } else {
            return Promise.resolve();
          }
        } else {
          return Promise.resolve();
        }
      },
    },
  ],
};
export default function getRules(type) {
  if (type === "personal") {
    return rules;
  } else {
    return {
      ...rules,
      name: [
        {
          required: true,
          message: "请输入公司名称",
          validateTrigger: ["onBlur", "onChange"],
        },
      ],
      id_no: [
        {
          required: true,
          message: "请输入单位代码",
          validateTrigger: ["onBlur", "onChange"],
        },
        {
          message: "请输入正确的统一社会信用代码，例如：912345678912345678",
          validateTrigger: ["onBlur", "onChange"],
          validator(_, value) {
            if (value) {
              const reg = /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/;

              if (reg.test(value)) {
                return Promise.resolve();
              } else {
                return Promise.reject();
              }
            } else {
              return Promise.resolve();
            }
          },
        },
      ],
    };
  }
}
